module.exports = __webpack_public_path__ + "img/cafeteria.e7c23479.jpg";